// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__WmMvh","col":"styles_col__3733F"};